import { contractString } from "../contractString";

export function getShortContractAddress(address: string) {
  return contractString(address, 14);
}
